import { ContainerPadding, CTA, Spinner, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { CheckmarkCircle } from '@volkswagen-onehub/icons-core';
import React, { useState } from 'react';
import { ErrorSection } from '../../../components/screen/error';
import { Section } from '../../../components/screen/section';
import { FIELD_NAME, FORM_MESSAGE, FORM_SUBMIT_STATUS } from '../../../constants/form-constants';
import { COLOR_TOKEN, STYLED_CTA } from '../../../constants/styles-constants';
import { ndpsEntity } from '../../../entities/ndps-entity';
import { formService } from '../../../form-service';
import { formDataBuilder, formDataFilter } from '../../../helpers/form-helpers';
import { sendForm } from '../../../service/api/send-form';
import { externalContentManager } from '../../../service/external-content';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';

interface Props {
	formData: () => Promise<any> | Record<string, any>;
	showInfoRequiredFields?: boolean;
	errorMessage?: string;
}

export function CallCenterEnvioSection(props: Props) {
	const { formData, showInfoRequiredFields = false, errorMessage } = props;
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);
	const [error, setError] = useState<boolean>();
	const [errorLog, setErrorLog] = useState<string>();
	const [invalid, setInvalid] = useState<boolean>();
	const trackingManager = useTrackingManager();
	//const { setAppSuccess } = useApp();

	const handleClick = async (e: React.SyntheticEvent) => {
		e.preventDefault();
		setSending(true);
		setError(false);
		setSent(false);
		setInvalid(false);

		const formDataResult = await formData();
		const isValid = formService.isFormValid();

		if (!isValid) {
			formService.setFormSubmitStatus(FORM_SUBMIT_STATUS.INVALID);
			setSending(false);
			setInvalid(true);
			return;
		}

		if (!formDataResult) {
			setSending(false);
			setError(true);
			return;
		}

		const dataToSend = formDataFilter({
			...ndpsEntity.commonData,
			...externalContentManager.dpsFields,
			...formDataResult,
		});

		formService.setFormSubmitStatus(FORM_SUBMIT_STATUS.SENDING);
		const { success, response } = await sendForm(formDataBuilder(dataToSend));
		formService.setFormSubmitStatus(success ? FORM_SUBMIT_STATUS.SUCCESS : FORM_SUBMIT_STATUS.ERROR);

		if (success) {
			setSent(true);
			//setAppSuccess(true); // Comentar para no mostrar Thankyou
			const fkSystem = (response as any)?.sent?.headers?.FK_SYSTEM;
			trackingManager.trackFormSubmissionSuccessMessageLoad(
				{ contentId: 'Envio correcto' },
				{
					LeadID: fkSystem,
					MarketingConsent: [
						{
							comunicaciones:
								formService.getFieldValue(FIELD_NAME.RGPD_COMUNICACIONES_COMERCIALES) == 'PERMITE' ? true : false,
							perfilado: formService.getFieldValue(FIELD_NAME.RGPD_PERFILADO) == 'PERMITE' ? true : false,
						},
					],
				},
			);
		} else {
			setErrorLog(JSON.stringify(response?.content));

			trackingManager.trackFormErrorMessageLoad({ message: FORM_MESSAGE.GENERIC_ERROR }, undefined);
		}

		setSending(false);
		setError(!success);
	};

	return (
		<>
			<Section paddingBottom={ContainerPadding.static200}>
				{showInfoRequiredFields && <Text appearance={TokenTextAppearance.copy200}>Campos obligatorios*</Text>}

				<div className="cta primary" style={{ width: STYLED_CTA.width }}>
					<CTA
						tag="button"
						emphasis="primary"
						onClick={handleClick}
						type="button"
						stretchContent
						disabled={sending}
						icon={sending ? <Spinner variant="default" /> : undefined}
						tabIndex={0}
					>
						{sending ? 'Enviando...' : 'Enviar'}
					</CTA>
				</div>
			</Section>
			{invalid ? <ErrorSection align="left">{FORM_MESSAGE.INVALID_FIELDS}</ErrorSection> : undefined}
			{sent && !error ? (
				<Section>
					<div
						style={{
							color: COLOR_TOKEN.displayTag.success.background,
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'left',
							alignItems: 'center',
							height: 'auto',
						}}
					>
						<div style={{ marginRight: '8px', color: COLOR_TOKEN.displayTag.success.background }}>
							<CheckmarkCircle variant="large" />
						</div>
						Datos enviados correctamente.
					</div>
				</Section>
			) : undefined}
			{!sending && error ? (
				<ErrorSection align="left" log={errorLog}>
					{errorMessage || FORM_MESSAGE.GENERIC_ERROR}
				</ErrorSection>
			) : undefined}
		</>
	);
}
